"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const LinkTile = (props) => {
    const { link } = props;
    return (react_1.default.createElement("div", { className: "znd-download-tile col-md-6", onClick: () => {
            window.open(link.url, '_blank');
        } },
        react_1.default.createElement("div", { className: "znd-download-tile__inner" },
            react_1.default.createElement("div", { className: "znd-download-tile__detail" },
                react_1.default.createElement("div", { className: "znd-download-tile__title t-subhead-1" }, link.name)),
            react_1.default.createElement(Icon_1.default, { className: "znd-download-tile__icon znd-download-tile__icon--external-link", name: Zupicons_1.default.externalLink }))));
};
exports.default = LinkTile;
